<template>
  <div class="br-price-slider">
    <h2
      class="u-margin-bottom-l">
      <span class="black">{{ model.size | numeral }}</span> team members
    </h2>
    <slider
      v-model="model.size"
      type="size"
      :min="10000"
      :max="250000"/>
    <h2><span class="blue">$ {{ getTotalPrice }}</span> per month</h2>
    <div class="text-group-vertical">
      <span class="text text--muted">You'll get a discount if you subscribe yearly</span>
      <span class="text text--muted"><strong>$ {{ getYearlyPrice | numeral }}</strong> per month</span>
    </div>
  </div>
</template>

<script>
import Slider from '@components/Slider'
import Pricing from '@mixins/Pricing'
import numeral from 'numeral'

export default {
  components: {
    Slider
  },
  mixins: [
    Pricing
  ],
  data: () => ({
    model: {
      size: 10000
    }
  }),
  computed: {
    getTotalPrice () {
      const total = this.getPricePerMember * this.model.size

      return numeral(total)
        .multiply(1 - 0.55)
        .format('0,0')
    },
    getPricePerMember () {
      const basePrice = this.$store.getters['pricing/getTotalPrice']

      const discount = (this.model.size - 10000) / (240000 * 20)

      return basePrice - (basePrice * discount / 100)
    },
    getYearlyPrice () {
      return Math.round(
        numeral(this.getTotalPrice)
          .multiply(0.90)
          .value() / 100
      ) * 100
    }
  },
  watch: {
    'model.size' (size) {
      this.$store.dispatch('pricing/setMembers', size)
    }
  },
  created () {
    this.initExchangeRate()
  }
}
</script>
